export const EXPLORABLE_EXERCISE = 'ExplorableExercise';
export const EXPORTED_EXERCISES = [EXPLORABLE_EXERCISE];